import { render, staticRenderFns } from "./ResultResearch.vue?vue&type=template&id=0d13e18c&"
import script from "./ResultResearch.vue?vue&type=script&lang=js&"
export * from "./ResultResearch.vue?vue&type=script&lang=js&"
import style0 from "./ResultResearch.vue?vue&type=style&index=0&id=0d13e18c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports